import React, { useState } from "react";
import { DashboardLayout } from "../../components/layout";

import OfferFilters from "../../components/dashboard/OfferFilters";
import OffersTable from "../../components/dashboard/OffersTable";
import ProductFilterModal from "../../components/filters/ProductFilterModal";
import { getGradeFilterList, getMaterialLocationFilterList } from "../../utils/api";
import AddOfferModal from "../../components/dashboard/AddOfferModal";

const MyOffers = () => {

    /*
    price: max 4 digits before decimals, decimals multiple of 5 and max 2 and always 2 so 0 after 3
    quantity: max 4 digits, no decimals
    */
    const [filters, setFilters] = useState({
        grade: null,
        area: null
    });
    const [showFilterPopup, setShowFilterPopup] = useState(false);

    const [refreshKey, setRefreshKey] = useState(0);

    const [showAddModal, setShowAddModal] = useState(false);

    const [offerEndTime, setOfferEndTime] = useState(null);

    const refreshOffers = () => {
        setRefreshKey(prev => prev + 1);
    };
    const offersFilterConfig = [
        { key: "grade", label: "Grade", api: getGradeFilterList },
        { key: "area", label: "Area", api: getMaterialLocationFilterList }
    ];
    const breadcrumbs = [
        { label: "Seller", link: "/dashboard" },
        { label: "My Offers" }
    ];

    return (

        <DashboardLayout className="relative" breadcrumbs={breadcrumbs}>

            <OfferFilters
                filters={filters}
                setFilters={setFilters}
                offerEndTime={offerEndTime}
                openFilters={() => setShowFilterPopup(true)}
                openAddOffer={() => setShowAddModal(true)}
            />

            <OffersTable
                filters={filters}
                refreshKey={refreshKey}
                setOfferEndTime={setOfferEndTime}
            />

            <ProductFilterModal
                open={showFilterPopup}
                onClose={() => setShowFilterPopup(false)}
                filters={filters}
                setFilters={setFilters}
                filterConfig={offersFilterConfig}
                onApply={refreshOffers}
            />
            <AddOfferModal
                open={showAddModal}
                onClose={() => setShowAddModal(false)}
                onSubmit={(payload) => {
                    console.log("Create offer:", payload);
                    refreshOffers();
                }}
            />


        </DashboardLayout >

    );
};

export default MyOffers;